<div class="p-modal-menu02__title">
  <h2 class="p-modal-menu02__title-label" [innerHTML]="'label.declineMeal' | staticMsg"></h2>
  <ul class="c-inline-list01">
    <li class="c-inline-list01__item" [innerHTML]="'label.ruleDetail' | staticMsg"></li>
  </ul>
</div>
<ul class="p-modal-menu02__list">
  <li class="p-modal-menu02__list-item">
    <button
      type="button"
      class="p-modal-menu02__btn p-modal-menu02__btn--arrow"
      id="decline-in-flight-meal"
      (click)="clickItem()"
    >
      <span class="p-modal-menu02__btn-inner">
        <span class="p-modal-menu02__btn-label" [innerHTML]="'label.declineMealOption' | staticMsg"></span>
      </span>
    </button>
  </li>
</ul>
